import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-100 bg-opacity-50" 
         (click)="onCancel()">
      <div class="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 overflow-hidden" 
           style="box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);"
           (click)="$event.stopPropagation()">
        <div class="bg-gray-100 px-4 py-1.5 border-b border-gray-200">
          <div class="m-0 text-[18px] font-medium text-gray-700 leading-tight">
            {{ data.title || 'Confirmação' }}
</div>
        </div>
        <div class="p-4">
          <p class="text-[11px] text-gray-600 leading-relaxed whitespace-pre-line mb-4">
            {{ data.message }}
          </p>
          <div class="flex justify-end gap-2">
            <button 
              type="button"
              (click)="onCancel()"
              class="px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
              Cancelar
            </button>
            <button 
              type="button"
              (click)="onConfirm()"
              class="px-3 py-1.5 text-xs font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title?: string; message: string }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}

